import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { logCustomEvent } from './brazeClient'

export const Braze: React.FC = () => {
  const location = useLocation()

  useEffect(() => {
    logCustomEvent('view_page', {
      page_url: window.location.href,
    })
  }, [location.pathname])

  return null
}
